import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(private http: HttpClient) { }

  CallAjaxUsingPostRequest(url: any, dataObject: any): Observable<any> {
    return this.http.post<any>(url, dataObject).pipe(
      tap(),
      catchError(this.handleError)
    )
  }
  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    }
    else {
      // errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
      errorMessage = 'Internal server error';
    }
    return throwError(errorMessage);
  }


}
